import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=1a32a19a&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=1a32a19a&lang=scss&scoped=true"
import style1 from "./StoreInfo.vue?vue&type=style&index=1&id=1a32a19a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32a19a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a32a19a')) {
      api.createRecord('1a32a19a', component.options)
    } else {
      api.reload('1a32a19a', component.options)
    }
    module.hot.accept("./StoreInfo.vue?vue&type=template&id=1a32a19a&scoped=true", function () {
      api.rerender('1a32a19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/clinic/StoreInfo.vue"
export default component.exports